<div class="slot"
  [ngClass]="{higlight:(data.higlight && !data.bookedhiglight && !hideAllGreen),small:data.type=='s',big:data.type =='b',medium:data.type =='m' }"
  [ngClass]="{higlightbooked:data.bookedhiglight,higlight:data.higlight,small:data.type=='s',medium:data.type=='m',big:data.type=='b' }">
  <div class="value" *ngIf="data.show">
    {{data.value}}
  </div>
  <div class="value" *ngIf="!data.show">
  </div>
</div>